module.exports = __webpack_public_path__ + "img/1F3F4.2653affa.svg";